const screenData = {
	screen:{
		email: {
			filterFields: [
				{name:"邮箱标题",id:"title"},
				{name:"当前投放状态",id:"status",child:[{name:"待发送",id:"0"},{name:"发送中",id:"1"},{name:"已发送",id:"2"}]},
			]
		},
		userBaseInfo:{
			filterFields:[
				{name:'用户ID', id:'open_id'},
				{name:'昵称', id:'username'},
				{name:'手机号',id:'mobile'},
				{name:'职业',id:'vocation',type:"more",child:["平面设计师","插画师","网页设计师","UI设计师","动画师","产品设计师","摄影师","学生","设计爱好者","UX设计师","新媒体设计师","特效设计师","服装设计师","教育工作者"]},
				{name:'供稿人类型',id:'contributor_type',child:[{name:"个人 ",id:"1"},{name:"企业",id:"2"}]},
				{name:'是否为平台供稿人',id:'is_contributor',child:[{name:"否",id:"0"},{name:"是",id:"1"}]},
				{name:'推荐等级',id:'recommend_level',type:"more",child:["S","A","B","C","不推荐"]},
				// {name:'推荐人昵称', id:'referrer_userrname'},
				{name:'推荐人ID', id:'referrer_id'},
				{name:'工作状态', id:'situation'},
				{name:'项目类型偏好', id:'preference_classify'},
				{name:'设计经验', id:'design_experience'},
				{name:'注册时间',type:"time",child:[{name:'注册时间(开始)',id:'create_time_min'},{name:'注册时间(开始)',id:'create_time_max'}]},
				{name:"",type:"display"}
			],

		},
		settlement:{
			filterFields:[
				{name:"项目名称",id:"name"},
				{name:"结算日期",id:"time"},
				{name:"用户昵称",id:"username"},
				{name:"项目ID",id:"project_id"},
				{name:"",type:"display"},
			],
		},
		addrelease:{
			filterFields:[
				{name:'用户id',id:'open_id'},
				{name:'性别',id:'sex',child:[{name:"男",id:"1"},{name:"女",id:"2"}]},
				{name:'是否为平台供稿人',id:'is_contributor',child:[{name:"否",id:"0"},{name:"是",id:"1"}]},
				{name:'供稿人类型',id:'contributor_type',child:[{name:"个人 ",id:"1"},{name:"企业",id:"2"}]},
				{name:'是否平台推荐创作者',id:'is_recommend',child:[{name:"是 ",id:"1"},{name:"否",id:"0"}]},
				{name:'推荐等级',id:'recommend_level',child:[{name:"S",id:"S"},{name:"A ",id:"A"},{name:"B",id:"B"},{name:"C",id:"C"},{name:"不推荐",id:"0"}]},
				//{name:'推荐等级',id:'recommend_level',type:"level",child:["A","B","C","S","不推荐"]},
				{name:'作品数量', type:'two',child:[{name:'作品数量下限',id:'works_num_min'},{name:'作品数量上限',id:'works_num_max'}]},
				{name:'关注人数', type:'two',child:[{name:'关注人数下限',id:'follow_num_min'},{name:'关注人数上限',id:'follow_num_max'}]},
				{name:'注册时间',id:'register_time',type:"time",child:[{name:'注册时间(开始)',id:'register_time_start'},{name:'注册时间(开始)',id:'register_time_end'}]},
				{name:'用户名',id:'username'},
				{name:'手机号',id:'mobile'},
				{name:'邮箱',id:'email'},
				{name:'职业',id:'vocation',type:"more",child:["平面设计师","插画师","网页设计师","UI设计师","动画师","产品设计师","摄影师","学生","设计爱好者","UX设计师","新媒体设计师","特效设计师","服装设计师","教育工作者"]},
				{name:'所在地',id:'address'},
				{name:'非认证微信',id:'weixin'},
				{name:'认证微信',id:'weixin_name'},
				{name:'非认证QQ',id:'qq'},
				{name:'认证QQ',id:'qq_name'},
				// {name:'非认证微博',id:'weibo'},
				{name:'认证微博',id:'weibo_name'},
				{name:"",type:"display"}
			],

		},

		projectreviewxb:{
			filterFields:[
				{name:"项目名称",id:"name"},
				{name:"业务类型",id:"business_type",type:"newselet",child:[]},
				{name:"提审用户昵称",id:"username"},
				{name:"当前状态", id:"select_status", child: [{name:"待选标",id:"0"}, {name:"已选标", id:"1"}]},
			],
		},
		projectreviewbm:{
			filterFields:[
				{name:"项目名称",id:"name"},
				{name:"业务类型",id:"business_type",type:"newselet",child:[]},
				{name:"提审用户昵称",id:"username"},
				{name:"审核状态", id:"check_status", child: [{name:"待审核",id:"0"},{name:"审核通过",id:"1"},{name:"审核驳回",id:"-1"},{name:"失效或撤回",id:"-2"}]},
				{name:'提审时间',type:"time",child:[{name:'提审时间(开始)',id:'created_at_start'},{name:'提审时间(开始)',id:'created_at_start_end'}]},
			],
		},

		addblack:{
			filterFields0:[
				{name:'用户id',id:'open_id'},
				{name:'性别',id:'sex',child:[{name:"男",id:"1"},{name:"女",id:"2"}]},
				{name:'是否为平台供稿人',id:'is_contributor',child:[{name:"否",id:"0"},{name:"是",id:"1"}]},
				{name:'供稿人类型',id:'contributor_type',child:[{name:"个人 ",id:"1"},{name:"企业",id:"2"}]},
				{name:'是否平台推荐创作者',id:'is_recommend',child:[{name:"是 ",id:"1"},{name:"否",id:"0"}]},
				{name:'推荐等级',id:'recommend_level',type:"more",child:["S","A","B","C","不推荐"]},
				//{name:'推荐等级',id:'recommend_level',type:"level",child:["A","B","C","S","不推荐"]},
				{name:'作品数量', type:'two',child:[{name:'作品数量下限',id:'works_num_min'},{name:'作品数量上限',id:'works_num_max'}]},
				{name:'关注人数', type:'two',child:[{name:'关注人数下限',id:'follow_num_min'},{name:'关注人数上限',id:'follow_num_max'}]},
				{name:'注册时间',id:'register_time',type:"time",child:[{name:'注册时间(开始)',id:'register_time_start'},{name:'注册时间(开始)',id:'register_time_end'}]},
				{name:'用户名',id:'username'},
				{name:'手机号',id:'mobile'},
				{name:'邮箱',id:'email'},
				{name:'职业',id:'vocation',type:"more",child:["平面设计师","插画师","网页设计师","UI设计师","动画师","产品设计师","摄影师","学生","设计爱好者","UX设计师","新媒体设计师","特效设计师","服装设计师","教育工作者"]},
				{name:'所在地',id:'address'},
				{name:'非认证微信',id:'weixin'},
				{name:'认证微信',id:'weixin_name'},
				{name:'非认证QQ',id:'qq'},
				{name:'认证QQ',id:'qq_name'},
				// {name:'非认证微博',id:'weibo'},
				{name:'认证微博',id:'weibo_name'},
				{name:"",type:"display"}
			],
			filterFields1:[
				{name:"举报单ID",id:"report_id"},
				{name:"举报者ID",id:"open_id"},
				{name:"举报者昵称",id:"username"},
				{name:"举报类型",id:"classify_id",child:[{name:"垃圾广告信息",id:"1"},{name:"涉黄涉暴等违法信息",id:"2"},{name:"侮辱、恶意及辱骂等行为",id:"3"},{name:"作品侵犯原作者权益",id:"4"},{name:"其他",id:"5"}]},
				{name:"举报对象ID",id:"accused_open_id"},
				{name:"举报对象昵称",id:"accused_username"},
				{name:"举报位置",id:"position",child:[{name:"作品举报",id:"work"},{name:"评论举报",id:"comment"},{name:"用户中心举报",id:"user"},{name:"私信举报",id:"message"}]},
				{name:"详细说明",id:"detail"},
				{name:'举报时间',type:"time",child:[{name:'举报时间(开始)',id:'create_time_start'},{name:'举报时间(开始)',id:'create_time_end'}]},

			]

		},
		newlistAd:{
			filterFields:[
				{name:"作品ID",id:"work_id"},
				{name:"作品标题",id:"work_name"},
				{name:"用户ID",id:"open_id"},
				{name:"用户昵称",id:"username"},
				{name:"是否为平台投稿作品",id:"is_platform_work",child:[{name:"否",id:"0"},{name:"是",id:"1"}]},
				{name:"是否已被录用",id:"is_hired",child:[{name:"否",id:"2"},{name:"是",id:"1"}]},
				{name:"当前状态",id:"status",child:[{name:"草稿",id:"-1"},{name:"待审核",id:"0"},{name:"审核驳回",id:"-2"},{name:" 审核通过",id:"2"},{name:"下架",id:"-3"},{name:" 用户删除",id:"-4"}]},
				{name:"",type:"display"}
			],
		},
		userCompanyInfo:{
			filterFields:[
				{name:"用户ID",id:"open_id"},
				{name:"用户昵称",id:"username"},
				{name:"手机号",id:"mobile"},
				{name:"邮箱",id:"email"},
				{name:"企业/机构名称",id:"company_name"},
				{name:"统一信用代码",id:"code",},
				{name:"提供发票税率",id:"tax_rate_type",child:[{name:"6%或17% ",id:"1"},{name:"3%",id:"2"}]},
				{name:"企业银行卡号",id:"bank_card_no"},
				{name:"所属开户银行",id:"bank_name"},
				{name:"所属开户支行",id:"branch_bank"},
				{name:'累积收益', type:'two',child:[{id:'profit_min',name:"累积收益下限"},{name:"累积收益上限",id:'profit_max'}]},
				{name:'累积录用作品数', type:'two',child:[{id:'hire_num_min',name:"累积录用作品数下限"},{id:'hire_num_max',name:"累积录用作品数上限"}]},
				{name:'认证时间',type:"time",child:[{name:'认证时间(开始)',id:'created_at_min'},{name:'认证时间(结束)',id:'created_at_max'}]},
			]
		},
		newproject1:{
			filterFields:[
				{name:'用户id',id:'open_id'},
				{name:'性别',id:'sex',child:[{name:"男",id:"1"},{name:"女",id:"2"}]},
				{name:'是否为平台供稿人',id:'is_contributor',child:[{name:"否",id:"0"},{name:"是",id:"1"}]},
				{name:'供稿人类型',id:'contributor_type',child:[{name:"个人 ",id:"1"},{name:"企业",id:"2"}]},
				{name:'是否为平台推荐创作者',id:'is_recommend',child:[{name:"是 ",id:"1"},{name:"否",id:"0"}]},
				{name:'推荐等级',id:'recommend_level',child:[{name:"S",id:"S"},{name:"A ",id:"A"},{name:"B",id:"B"},{name:"C",id:"C"},{name:"不推荐",id:"0"}]},
				//{name:'推荐等级',id:'recommend_level',type:"level",child:["A","B","C","S","不推荐"]},
				{name:'作品数量', type:'two',child:[{name:'作品数量下限',id:'works_num_min'},{name:'作品数量上限',id:'works_num_max'}]},
				{name:'关注人数', type:'two',child:[{name:'关注人数下限',id:'follow_num_min'},{name:'关注人数上限',id:'follow_num_max'}]},
				{name:'注册时间',id:'register_time',type:"time",child:[{name:'注册时间(开始)',id:'register_time_start'},{name:'注册时间(开始)',id:'register_time_end'}]},
				{name:'用户名',id:'username'},
				{name:'手机号',id:'mobile'},
				{name:'邮箱',id:'email'},
				{name:'职业',id:'vocation',type:"more",child:["平面设计师","插画师","网页设计师","UI设计师","动画师","产品设计师","摄影师","学生","设计爱好者","UX设计师","新媒体设计师","特效设计师","服装设计师","教育工作者"]},
				{name:'所在地',id:'address'},
				{name:'非认证微信',id:'weixin'},
				{name:'认证微信',id:'weixin_name'},
				{name:'非认证QQ',id:'qq'},
				{name:'认证qq',id:'qq_name'},
				{name:'非认证微博',id:'weibo'},
				{name:'认证微博',id:'weibo_name'},
				{name:"",type:"display"}
			]
		},
		newprojectrecommende:{
			filterFields: [
				{name:"项目ID",id:"project_id"},
				{name:"项目名称",id:"name"},
				{name:"业务类型",id:"business_type",child:[{name:"广告模板 ",id:"1"},{name:"广告图",id:"2"},{name:"场景主题",id:"3"},{name:"主题",id:"4"}]},
				{name:"领域范围",id:"fields"},
				{name:"发布时间",id:"publish_time",type:"time",child:[{name:'发布时间(开始)',id:'publish_time_start'},{name:'发布时间(开始)',id:'publish_time_end'}]},
				{name:"中标时间",id:"bidding_time",type:"time",child:[{name:'中标时间(开始)',id:'bidding_time_start'},{name:'中标时间(开始)',id:'bidding_time_end'}]},
				{name:"截稿时间",id:"deadline",type:"time",child:[{name:'截稿时间(开始)',id:'deadline_start'},{name:'截稿时间(开始)',id:'deadline_end'}]},
			],

		},
		newproject2:{
			filterFields:[
				{name:"模板名称",id:"template_name"},
				{name:"所属项目分类",id:"classify_name"},
				{name:"状态",id:"status",child:[{name:"禁用",id:"0"},{name:"启用",id:"1"}]},
				{type:"display",prop:'t',lable:'额外赏金'},
			]
		},
		userPersonalInfo:{
			filterFields:[
				{name:"用户ID",id:"open_id"},
				{name:"用户昵称",id:"username"},
				{name:"手机号",id:"mobile"},
				{name:"手机号",id:"reserve_phone"},
				{name:"邮箱",id:"email"},
				{name:"身份证姓名",id:"real_name"},
				{name:"身份证号码",id:"id_card"},
				{name:"收款账号名",id:"account_name"},
				{name:"银行卡号",id:"bank_card_no"},
				{name:"银行预留手机号",id:"reserve_phone"},
				{name:"所属开户银行",id:"bank_name"},
				{name:"所属开户支行",id:"branch_bank"},
				{name:'累积收益', type:'two',child:[{id:'profit_min',name:"累积收益下限"},{name:"累积收益上限",id:'profit_max'}]},
				{name:'累积录用作品数量', type:'two',child:[{id:'hire_num_min',name:"累积录用作品数下限"},{id:'hire_num_max',name:"累积录用作品数上限"}]},
				{name:'认证时间',type:"time",child:[{name:'认证时间(开始)',id:'created_at_min'},{name:'认证时间(结束)',id:'created_at_max'}]},
			]
		},
		roleManager:{
			filterFields:[
				{name:"角色ID",id:"id"},
				{name:"角色名称",id:"role_name",type:"text"},
				{name:'创建时间',id:'register_time',type:"time",child:[{name:'创建时间(开始)',id:'create_time_start'},{name:'创建时间(开始)',id:'create_time_end'}]},
			]
		},
		accountManager:{
			filterFields:[
				{name:"账号ID",id:"id"},
				{name:"角色ID",id:"role_id"},
				{name:"账户名",id:"name"},
				{name:"邮箱",id:"email"},
			]
		},
		publishWork:{
			filterFields:[
				{name:"作品ID",id:"work_id"},
				{name:"作品标题",id:"work_name"},
				{name:"提审用户ID",id:"open_id"},
				{name:"提审用户昵称",id:"username"},
				{name:'提审时间',type:"time",child:[{name:'提审时间(开始)',id:'create_time_start'},{name:'提审时间(开始)',id:'create_time_end'}]},
				{name:"审核状态",id:"check_status",child:[{name:"待审核",id:"0"},{name:"审核通过",id:"1"},{name:"审核驳回",id:"-1"},{name:"失效或撤回",id:"-2"}]},
				{name:"审核人",id:"reviewer"},
				{name:'审核时间',type:"time",child:[{name:'审核时间(开始)',id:'review_time_start'},{name:'审核时间(开始)',id:'review_time_end'}]},
			]
		},
		finalistsWork:{
			filterFields:[
				{name:"作品ID",id:"work_id"},
				{name:"作品名称",id:"work_name"},
				{name:"活动ID",id:"activity_id"},
				{name:"活动名称",id:"activity_name"},
				{name:"提审用户ID",id:"open_id"},
				{name:"提审用户昵称",id:"username"},
				{name:'提审时间',type:"time",child:[{name:'提审时间(开始)',id:'create_time_start'},{name:'提审时间(开始)',id:'create_time_end'}]},
				{name:"审核状态",id:"check_status",child:[{name:"待审核",id:"0"},{name:"审核通过",id:"1"},{name:"审核驳回",id:"-1"},{name:"失效或撤回",id:"-2"}]},
				{name:"审核人",id:"reviewer"},
				{name:'审核时间',type:"time",child:[{name:'审核时间(开始)',id:'review_time_start'},{name:'审核时间(开始)',id:'review_time_end'}]},
				{name:"",type:"display"}
			]
		},
		employWork:{
			filterFields:[
				{name:"审核ID",id:"id"},
				{name:"作品ID",id:"work_id"},
				{name:"作品名称",id:"work_name"},
				{name:"活动ID",id:"activity_id"},
				{name:"活动名称",id:"activity_name"},
				{name:"提审用户ID",id:"open_id"},
				{name:"提审用户昵称",id:"username"},
				{name:'提审时间',type:"time",child:[{name:'提审时间(开始)',id:'create_time_start'},{name:'提审时间(开始)',id:'create_time_end'}]},
				{name:"审核状态",id:"check_status",child:[{name:"待审核",id:"0"},{name:"审核通过",id:"1"},{name:"审核驳回",id:"-1"},{name:"失效或撤回",id:"-2"}]},
				{name:'审核时间',type:"time",child:[{name:'审核时间(开始)',id:'review_time_start'},{name:'审核时间(开始)',id:'review_time_end'}]},
				{name:"审核人",id:"reviewer"},
				{name:"",type:"display"}
			]
		},
		projectreview:{
			filterFields:[
				{name:"审核ID",id:"id"},
				{name:"项目ID",id:"project_id"},
				{name:"项目名称",id:"name"},
				{name:"项目类型",id:"classify_id",child:[]},
				{name:"业务类型",id:"business_type",type:"newselet",child:[]},
				{name:"提审用户昵称",id:"username"},
				{name:"审核状态",id:"check_status",child:[{name:"待审核",id:"0"},{name:"审核通过",id:"1"},{name:"审核驳回",id:"-1"},{name:"失效或撤回",id:"-2"}]},
				{name:"",type:"display"}
			]
		},
		projectreview1:{
			filterFields:[
				{name:"审核ID",id:"id"},
				{name:"项目名称",id:"name"},
				{name:"项目类型",id:"classify_id",child:[]},
				{name:"业务类型",id:"business_type",type:"more",child:["场景主题","个性化主题","来电秀","其他","杂志锁屏","投稿作品","贴纸花字（华为）"]},

				{name:"提审用户昵称",id:"username"},
				{name:"",type:"display"}
			]
		},
		applyPerson:{
			filterFields:[
				{name:"审核ID",id:"id"},
				{name:"账号主体",id:"contributor_type"},
				{name:"提审用户ID",id:"open_id"},
				{name:"提审用户昵称",id:"username"},
				{name:'提审时间',type:"time",child:[{name:'提审时间(开始)',id:'create_time_start'},{name:'提审时间(开始)',id:'create_time_end'}]},
				{name:"审核状态",id:"check_status",child:[{name:"待审核",id:"0"},{name:"审核通过",id:"1"},{name:"审核驳回",id:"-1"},{name:"失效或撤回",id:"-2"}]},
				{name:"审核人",id:"reviewer"},
				{name:'审核时间',type:"time",child:[{name:'审核时间(开始)',id:'review_time_start'},{name:'审核时间(开始)',id:'review_time_end'}]},
				{name:"",type:"display"}
			]
		},
		workInfo:{
			filterFields:[
				{name:"作品ID",id:"work_id"},
				{name:"作品标题",id:"work_name"},
				{name:"用户ID",id:"open_id"},
				{name:"用户昵称",id:"username"},
				{name:"作品类型",id:"classify",type:"linkage",child:[]},
				{name:"版权说明",id:"copyright",child:[{name:"禁止匿名转载；禁止商业使用；禁止个人使用。",id:"禁止匿名转载；禁止商业使用；禁止个人使用。"},{name:"禁止匿名转载；禁止商业使用。",id:"禁止匿名转载；禁止商业使用。"},{name:"不限制作品用途。",id:"不限制作品用途。"}]},
				{name:"作品标签",id:"labels"},
				{name:"是否为平台投稿作品",id:"is_platform_work",child:[{name:"否",id:"0"},{name:"是",id:"1"}]},
				// {name:"是否已被录用",id:"is_hired",child:[{name:"否",id:"2"},{name:"是",id:"1"}]},
				{name:"录用方式",id:"hire_type",child:[{name:"买断式",id:"1"},{name:"分成式",id:"2"}]},
				{name:"录用活动ID",id:"activity_id"},
				{name:"录用订单ID",id:"hire_id"},
				{name:"录用订单名称",id:"hire_order_name"},
				/* {name:"投放状态",id:"ids",child:[{name:"无",id:"1"},{name:"未投放",id:"1"},{name:"上线中",id:"1"},{name:"已下线",id:"1"}]}, */
				{name:'创建时间',type:"time",child:[{name:'创建时间(开始)',id:'create_time_start'},{name:'创建时间(开始)',id:'create_time_end'}]},
				{name:'最近更新时间',type:"time",child:[{name:'最近更新时间(开始)',id:'update_time_start'},{name:'最近更新时间(开始)',id:'update_time_end'}]},
				/* {name:"作品预览链接",id:"ids"}, */
				{name:"当前状态",id:"status",child:[{name:"草稿",id:"-1"},{name:"待审核",id:"0"},{name:"审核驳回",id:"-2"},{name:" 审核通过",id:"2"},{name:"下架",id:"-3"},{name:" 用户删除",id:"-4"}]},
			]
		},
		materialBank:{
			filterFields:[
				{name:"附加ID",id:"fid"},
				{name:"文件名称",id:"file_name"},
				{name:"文件格式",id:"file_type",child:[{name:" 图片",id:"image"},{name:"音频",id:"audio"},{name:"视频",id:"video"},{name:"附件",id:"zip"}]},
				{name:"作品ID",id:"work_id"},
				{name:"作品类型",id:"classify_1"},
				{name:"作品名称",id:"work_name"},
				{name:"用户ID",id:"open_id"},
				{name:"用户昵称",id:"username"},
				{name:"创作者职业",id:"vocation"},
				{name:"是否为平台推荐作品",id:"is_recommend",child:[{name:"否",id:"0"},{name:"是",id:"1"}]},
				{name:"推荐评级",id:"recommend_level",child:[{name:"S",id:"S"},{name:"A",id:"A"},{name:"B",id:"B"},{name:"C",id:"C"}]},
				{name:"是否为平台投稿作品",id:"is_platform_work",child:[{name:"否",id:"0"},{name:"是",id:"1"}]},
				{name:"是否已被录用",id:"is_hired",child:[{name:"否",id:"2"},{name:"是",id:"1"}]},
				{name:'创建时间',type:"time",child:[{name:'创建时间(开始)',id:'create_time_start'},{name:'创建时间(开始)',id:'create_time_end'}]},
				{name:"当前状态",id:"status",child:[{name:"待审核",id:"0"},{name:"审核中",id:"1"},{name:" 审核通过",id:"2"},{name:" 未通过",id:"-2"}]},
			]
		},
		worksShelves:{
			filterFields:[
				{name:"举报单ID",id:"report_id"},
				{name:"举报者ID",id:"open_id"},
				{name:"举报者昵称",id:"username"},
				{name:"举报类型",id:"classify_id",child:[{name:"垃圾广告信息",id:"1"},{name:"涉黄涉暴等违法信息",id:"2"},{name:"侮辱、恶意及辱骂等行为",id:"3"},{name:"作品侵犯原作者权益",id:"4"},{name:"其他",id:"5"}]},
				{name:"举报对象ID",id:"accused_open_id"},
				{name:"举报对象昵称",id:"accused_username"},
				{name:"举报位置",id:"position",child:[{name:"作品举报",id:"work"},{name:"评论举报",id:"comment"},{name:"用户中心举报",id:"user"},{name:"私信举报",id:"message"}]},
				{name:"详细说明",id:"hire_order_name"},
				{name:'举报时间',type:"time",child:[{name:'举报时间(开始)',id:'create_time_start'},{name:'举报时间(开始)',id:'create_time_end'}]},

			]
		},
		commentManager:{
			filterFields:[
				{name:"评论ID",id:"comment_id"},
				{name:"评论人ID",id:"open_id"},
				{name:"评论人昵称",id:"username"},
				{name:"作品ID",id:"work_id"},
				{name:"作品名称",id:"work_name"},
				{name:"评论类型",id:"type",child:[{name:"评论",id:"1"},{name:"回复",id:"2"}]},
				{name:"评论内容",id:"content"},
				{name:"评论回复对象（用户ID）",id:"to_open_id"},
				{name:'创建时间',type:"time",child:[{name:'创建时间(开始)',id:'create_time_start'},{name:'创建时间(开始)',id:'create_time_end'}]},
			]
		},
		activityClass:{
			filterFields:[
				{name:"主题分类ID",id:"id"},
				{name:"主题分类名称",id:"category_name"},
				{name:"使用状态",id:"status",child:[{name:"启用",id:"1"},{name:"停用",id:"2"}]},
			]
		},
		activityEmploy:{
			filterFields:[
				{name:"活动ID",id:"activity_id"},
				{name:"活动名称",id:"activity_name" },
				{name:"活动类型",id:"type"},
				{name:"主题分类",id:"category_name",
					child:()=>{

						//setTimeout(function(){
							let a = localStorage.getItem("child") ;
							if(!a){
								a = [];
							}
						//},500)

						return JSON.parse(a);
					}
				},
				/* {name:"活动时间",id:"id",type:"time"}, */
				{name:"当前状态",id:"status",child:[{name:"未开始",id:"0"},{name:"进行中",id:"1"},{name:"已结束",id:"-1"}]},
				{name:"作品上传和展示",id:"setting_type",child:[{name:"不支持上传",id:"1"},{name:"支持上传，不支持展示作品",id:"2"},{name:"支持上传，仅展示入围作品",id:"3"},{name:"支持上传，并展示入围和录用作品",id:"4"}]},
				{name:"入围作品数量",id:"id",type:"two",child:[{id:"shortlisted_num_min",name:"入围作品数量下限"},{id:"shortlisted_num_max",name:"入围作品数量上限"}]},
				{name:"录用作品数量",id:"ids",type:"two",child:[{id:"hire_num_min",name:"录用作品数量下限"},{id:"hire_num_max",name:"录用作品数量下限"}]},
				{name:"",type:"display"},
			]
		},
		newrecommendedActivities:{
			filterFields:[
				{name:"活动ID",id:"activity_id"},
				{name:"活动名称",id:"activity_name"},
				{name:"活动类型",id:"type"},
				{name:"主题分类",id:"category_id"},
				/* {name:"活动时间",id:"id",type:"time"}, */
				{name:"当前状态",id:"status",child:[{name:"未开始",id:"0"},{name:"进行中",id:"1"},{name:"已结束",id:"-1"},{name:"已删除",id:"-2"}]},
				{name:"作品上传和展示",id:"setting_type",child:[{name:"不支持上传",id:"1"},{name:"支持上传，不支持展示作品",id:"2"},{name:"支持上传，仅展示入围作品",id:"3"},{name:"支持上传，并展示入围和录用作品",id:"4"}]},
				{name:"入围作品数量",id:"id",type:"two",child:[{id:"shortlisted_num_min",name:"入围作品数量下限"},{id:"shortlisted_num_max",name:"入围作品数量上限"}]},
				{name:"录用作品数量",id:"id",type:"two",child:[{id:"hire_num_min",name:"录用作品数量下限"},{id:"hire_num_max",name:"录用作品数量下限"}]},
			]
		},
		labels:{
			filterFields:[
				{name:"标签词",id:"label"},
				{name:"被搜索次数",id:"count"},
				{name:"",type:"display"},
			]
		},
		activityworks:{
			filterFields:[
				{name:"用户ID",id:"open_id"},
				{name:"用户名称",id:"username"},
				{name:"作品ID",id:"work_id"},
				{name:"作品名称",id:"work_name"},
				{name:"活动ID",id:"activity_id"},
				{name:"活动名称",id:"activity_name"},
				{name:"当前状态",id:"status",child:[{name:"入围未录用",id:"-2"},{name:"未入围",id:"-1"},{name:"待入围审核",id:"0"},{name:"待录用审核",id:"1"},{name:"已录用",id:"2"},{name:"已入围",id:"11"},{name:"已参加",id:"10"}]},
				{name:'录用时间',type:"time",child:[{name:'录用时间(开始)',id:'hire_time_start'},{name:'录用时间(开始)',id:'hire_time_end'}]},
				{name:'入围时间',type:"time",child:[{name:'入围时间(开始)',id:'shortlisted_time_start'},{name:'入围时间(开始)',id:'shortlisted_time_end'}]},
			]
		},
		solicitationTemplate:{
			filterFields0:[
				{name:"模板文件ID",id:"template_file_id"},
				{name:"文件名称",id:"file_name"},
				{name:"文件格式",id:"file_type",},
				{name:"文件大小",id:"file_size_type",child:[{name:"小于10M",id:"1"},{name:"10M-100M",id:"2"},{name:"100M-1GB",id:"3"},{name:"大于1GB",id:"4"}]},
				{name:'在用活动数', type:'two',child:[{name:'在用活动数下限',id:'processing_activity_min'},{name:'在用活动数上限',id:'processing_activity_max'}]},
				{name:"上传人",id:"admin_name"},
				{name:'最近更新时间',type:"time",child:[{name:'最近更新时间(开始)',id:'update_time_start'},{name:'最近更新时间(开始)',id:'update_time_end'}]},
				{name:'上传时间',type:"time",child:[{name:'上传时间(开始)',id:'create_time_start'},{name:'上传时间(开始)',id:'create_time_end'}]},
				{name:"",type:"display"},
			],
			filterFields1:[
				{name:"模板文件ID",id:"template_file_id"},
				{name:"文件名称",id:"file_name"},
				{name:'在用活动数', type:'two',child:[{name:'在用活动数下限',id:'processing_activity_min'},{name:'在用活动数上限',id:'processing_activity_max'}]},
				{name:"上传人",id:"admin_name"},
				{name:'最近更新时间',type:"time",child:[{name:'最近更新时间(开始)',id:'update_time_start'},{name:'最近更新时间(开始)',id:'update_time_end'}]},
				{name:'上传时间',type:"time",child:[{name:'上传时间(开始)',id:'create_time_start'},{name:'上传时间(开始)',id:'create_time_end'}]},
				{name:"",type:"display"},
			]
		},
		newActivity:{
			filterFields0:[
				{name:"模板文件ID",id:"template_file_id"},
				{name:"文件名称",id:"file_name"},
				{name:"文件格式",id:"file_type",},
				{name:"文件大小",id:"file_size_type",child:[{name:"小于10M",id:"1"},{name:"10M-100M",id:"2"},{name:"100M-1GB",id:"3"},{name:"大于1GB",id:"4"}]},
				{name:'在用活动数', type:'two',child:[{name:'在用活动数下限',id:'processing_activity_min'},{name:'在用活动数上限',id:'processing_activity_max'}]},
				{name:"上传人",id:"admin_name"},
				{name:'最近更新时间',type:"time",child:[{name:'最近更新时间(开始)',id:'update_time_start'},{name:'最近更新时间(开始)',id:'update_time_end'}]},
				{name:'上传时间',type:"time",child:[{name:'上传时间(开始)',id:'create_time_start'},{name:'上传时间(开始)',id:'create_time_end'}]},
				{name:"",type:"display"},
			],
			filterFields1:[
				{name:"模板文件ID",id:"template_file_id"},
				{name:"文件名称",id:"file_name"},
				{name:'在用活动数', type:'two',child:[{name:'在用活动数下限',id:'processing_activity_min'},{name:'在用活动数上限',id:'processing_activity_max'}]},
				{name:"上传人",id:"admin_name"},
				{name:'最近更新时间',type:"time",child:[{name:'最近更新时间(开始)',id:'update_time_start'},{name:'最近更新时间(开始)',id:'update_time_end'}]},
				{name:'上传时间',type:"time",child:[{name:'上传时间(开始)',id:'create_time_start'},{name:'上传时间(开始)',id:'create_time_end'}]},
				{name:"",type:"display"},
			]
		},
		homeBanner:{
			filterFields0:[
				{name:"banner素材ID",id:"id"},
				{name:"banner素材名称",id:"banner_name"},
				{name:'创建时间',type:"time",child:[{name:'创建时间(开始)',id:'create_time_start'},{name:'创建时间(开始)',id:'create_time_end'}]},
				{name:"当前状态",id:"status",child:[{name:"待使用",id:"1"},{name:" 未使用",id:"0"},{name:"线上展示中",id:"2"}]},
			],
			filterFields1:[
				{name:"banner展示方案ID",id:"id"},
				{name:"banner展示方案名称",id:"banner_program_name"},
				{name:'干预时间',type:"time",child:[{name:'干预时间(开始)',id:'program_begin_time'},{name:'干预时间(开始)',id:'program_end_time'}]},
				{name:"当前状态",id:"status",child:[{name:"待使用",id:"1"},{name:" 未使用",id:"0"},{name:"线上展示中",id:"2"}]},
				{name:"是否为默认展示方案",id:"is_default",child:[{name:"是",id:"1"},{name:" 否",id:"0"}]},
				{name:"",type:"display"},
            ],
            filterFields2:[
				{name:"banner展示方案ID",id:"id"},
				{name:"banner展示方案名称",id:"banner_program_name"},
				{name:'干预时间',type:"time",child:[{name:'干预时间(开始)',id:'program_begin_time'},{name:'干预时间(开始)',id:'program_end_time'}]},
				{name:"当前状态",id:"status",child:[{name:"待使用",id:"1"},{name:" 未使用",id:"0"},{name:"线上展示中",id:"2"}]},
				{name:"是否为默认展示方案",id:"is_default",child:[{name:"是",id:"1"},{name:" 否",id:"0"}]},
				{name:"",type:"display"},
            ]
		},
		addbannerScheme:{
			filterFields:[
				{name:"banner素材ID",id:"id"},
				{name:"banner素材名称",id:"banner_name"},
				{name:'创建时间',type:"time",child:[{name:'创建时间(开始)',id:'create_time_start'},{name:'创建时间(开始)',id:'create_time_end'}]},
				{name:"当前状态",id:"status",child:[{name:"待使用",id:"1"},{name:" 未使用",id:"0"},{name:"线上展示中",id:"2"}]},
			]
		},
		hotWordSearch:{
			filterFields:[
				{name:"热门搜索词ID",id:"id"},
				{name:"文案",id:"word"},
				{name:"干预位置",id:"position",child:[
					{name:"第一位",id:"1"},
					{name:"第二位",id:"2"},
					{name:"第三位",id:"3"},
					{name:"第四位",id:"4"},
					{name:"第五位",id:"5"}
				]},
				{name:"当前状态",id:"status",child:[{name:"已删除",id:"-2"},{name:"已过期",id:"-1"},{name:"待使用",id:"0"},{name:"线上展示中",id:"1"}]},
				{name:'干预时间',type:"time",child:[{name:'干预时间(开始)',id:'start_time'},{name:'干预时间(开始)',id:'end_time'}]},
				{name:"",type:"display"},
			]
		},
		blackList:{
			filterFields:[
				{name:"禁用ID",id:"id"},
				{name:"用户ID",id:"open_id"},
				{name:"用户昵称",id:"username"},
				{name:"禁用权限",id:"access",child:[]},
				{name:"当前状态",id:"status",child:[{name:"失效",id:"0"},{name:"生效",id:"1"}]},
				{name:"",type:"display"},
			]
		},
		serviceCenter:{
			filterFields:[
				{name:"文档ID",id:"id"},
				{name:"文档备注",id:"remark"},
				{name:"文档类型",id:"type",child:[{name:"关于我们",id:"1"},{name:"用户协议",id:"2"},{name:"授权协议",id:"3"},{name:"帮助中心",id:"4"},{name:"常见问题",id:"5"},{name:"来电秀app工具",id:"6"},{name:"狮映-用户协议",id:"7"},{name:"狮映-供稿人协议",id:"8"},{name:"锁屏工具-用户协议",id:"9"}]},
				{name:"干预位置",id:"position",child:[
					{name:"第一位",id:"1"},
					{name:"第二位",id:"2"},
					{name:"第三位",id:"3"},
					{name:"第四位",id:"4"}
				]},
				{name:"当前状态",id:"status",child:[{name:"已删除",id:"-2"},{name:"已过期",id:"-1"},{name:"未开始",id:"0"},{name:"线上展示中",id:"1"}]},
				{name:'干预时间',type:"time",child:[{name:'更新时间(开始)',id:'update_time_start'},{name:'更新时间(开始)',id:'update_time_end'}]},
				{name:"",type:"display"},
			]
		},
		recommendedActivities:{
			filterFields:[
				{name:"任务ID",id:"id"},
				{name:"活动名称",id:"activity_name"},
				{name:"干预位置",id:"position",child:[
					{name:"第一位",id:"1"},
					{name:"第二位",id:"2"},
					{name:"第三位",id:"3"},
					{name:"第四位",id:"4"}
				]},
				{name:"当前状态",id:"status",child:[{name:"已删除",id:"-2"},{name:"已过期",id:"-1"},{name:"待使用",id:"0"},{name:"线上展示中",id:"1"}]},
				{name:'干预时间',type:"time",child:[{name:'干预时间(开始)',id:'start_time'},{name:'干预时间(开始)',id:'end_time'}]},
				{name:"",type:"display"},
			]
		},
		listAd:{
			filterFields:[
				{name:"任务ID",id:"id"},
				{name:"作品ID",id:"work_id"},
				{name:"作品名称",id:"work_name"},
				{name:"干预位置",id:"position"},
				{name:'干预时间',type:"time",child:[{name:'干预时间(开始)',id:'start_time'},{name:'干预时间(开始)',id:'end_time'}]},
				{name:"当前状态",id:"status",child:[{name:"已过期",id:"-1"},{name:"待上线",id:"0"},{name:"干预中",id:"1"}]},
				{name:"",type:"display"},
			]
		},
		employmentorder:{
			filterFields:[
				{name:"录用订单ID",id:"id"},
				{name:"订单名称",id:"hire_order_name"},
				{name:"作品ID",id:"work_id"},
				{name:"作品名称",id:"work_name",},
				{name:"用户ID",id:"open_id"},
				{name:"用户名称",id:"username"},
				{name:"录用方式",id:"hire_type",child:[{name:"买断式",id:"1"}]},
				{name:"录用审核人",id:"check_admin"},
				{name:"",type:"display"},
			]
		},
		channel:{
			filterFields:[
				{name:"录用订单ID",id:"id"},
				{name:"录用订单名称",id:"hire_order_name"},
				{name:"作品ID",id:"work_id"},
				{name:"作品名称",id:"work_name",},
				{name:"用户ID",id:"open_id"},
				{name:"用户名称",id:"username"},
				{name:'结算日期',type:"time",child:[{name:'结算日期(开始)',id:'start_date'},{name:'结算日期(结束)',id:'end_date'}]},
			]
		},
		embodyRecord:{
			filterFields:[
				{name:"提现单ID",id:"apply_id"},
				{name:"提现用户ID",id:"open_id"},
				{name:"提现用户账户名",id:"account_name"},
				{name:"提现金额",type:"two",child:[{name:'提现金额（起始）',id:'cash_money_start'},{name:'提现金额（截止）',id:'cash_money_end'}]},
				{name:"账号主体",id:"contributor_type",child:[{name:"个人",id:"1"},{name:"企业",id:"2"}]},
				{name:"状态",id:"check_status",child:[{name:"待审核",id:"0"},{name:"审核中",id:"1"},{name:"审核通过",id:"2"},{name:"已付款",id:"3"},{name:"审核不通过",id:"-1"},{name:"申请已撤销",id:"-2"}]},
				{name:"审核时间（开始）",type:"time",child:[{name:'审核时间(开始)',id:'check_time_start'},{name:'审核时间(结束)',id:'check_time_end'}]},
				{name:"处理时间（开始）",type:"time",child:[{name:'处理时间(开始)',id:'apply_time_start'},{name:'处理时间(结束)',id:'apply_time_end'}]},
				{name:"",type:"display"},
			]
		},
		presetReason:{
			filterFields:[
				{name:"驳回理由预设ID",id:"id"},
				{name:"审核类型",id:"type",child:[
					{name:"作品发布 ",id:"1"},
					{name:"作品入围 ",id:"2"},
					{name:"作品审核 ",id:"3"},
					{name:"平台供稿人 ",id:"4"},
					{name:"项目验收 ",id:"5"},
					{name:"项目报名 ",id:"6"},
				]},
				{name:"驳回理由",id:"content",},
				{name:"状态",id:"status",child:[
					{name:"启用 ",id:"1"},
					{name:"停用 ",id:"0"}
				]},
				{name:'创建时间',type:"time",child:[{name:'创建时间(开始)',id:'create_time_start'},{name:'创建时间(结束)',id:'create_time_end'}]},
				{name:"",type:"display"},
			]
		},
		feedback:{
			filterFields0:[
				{name:"意见反馈ID",id:"feedback_id"},
				{name:"用户昵称",id:"username"},
				{name:"驳回理由",id:"classify_id",child:[{name:"功能问题",id:"1"},{name:"设计问题",id:"2"},{name:"作品问题",id:"3"},{name:"未知问题",id:"4"},{name:"其他",id:"5"}]},
				{name:"联系方式",id:"link"},
				{name:'反馈时间',type:"time",child:[{name:'反馈时间(开始)',id:'create_time_start'},{name:'反馈时间(结束)',id:'create_time_end'}]},
				{name:"",type:"display"},
			],
			filterFields1:[
				/* {name:"驳回理由预设ID",id:"id"},
				{name:"审核类型",id:"work_id"},
				{name:"驳回理由",id:"work_name",},
				{name:"状态",id:"username"},
				{name:"创建时间（开始）",id:"ids",type:"time"},
				{name:"创建时间（结束）",id:"ids1",type:"time"}, */
			]
		},
		reportInfo:{
			filterFields0:[
				{name:"举报ID",id:"report_id"},
				{name:"举报用户ID",id:"open_id"},
				{name:"举报对象ID",id:"accused_open_id"},
				{name:"用户昵称",id:"username"},
				{name:"举报对象昵称",id:"accused_username"},
				{name:"举报位置",id:"position",child:[{name:"作品举报",id:"work"},{name:"评论举报",id:"comment"},{name:"用户中心举报",id:"user"},{name:"私信举报",id:"message"}]},
				{name:"举报类别",id:"classify_id",child:[{name:"垃圾广告信息",id:"1"},{name:"涉黄涉暴等违法信息",id:"2"},{name:"侮辱、恶意及辱骂等行为",id:"3"},{name:"作品侵犯原作者权益",id:"4"},{name:"其他",id:"5"}]},
				{name:'举报时间',type:"time",child:[{name:'举报时间(开始)',id:'create_time_start'},{name:'举报时间(结束)',id:'create_time_end'}]},
				{name:"",type:"display"},
			],
			filterFields1:[
				/* {name:"驳回理由预设ID",id:"id"},
				{name:"审核类型",id:"work_id"},
				{name:"驳回理由",id:"work_name",},
				{name:"状态",id:"username"},
				{name:"创建时间（开始）",id:"ids",type:"time"},
				{name:"创建时间（结束）",id:"ids1",type:"time"}, */
				{}
			]
		},
		newsRelease:{
			filterFields:[
				{name:"通知ID",id:"id"},
				{name:"通知标题",id:"title"},
				{name:'发送用户数', type:'two',child:[{name:'作品数量下限',id:'send_num_min'},{name:'作品数量上限',id:'send_num_max'}]},
				{name:'最近更新时间',type:"time",child:[{name:'最近更新时间(开始)',id:"update_time_start"},{name:'最近更新时间(结束)',id:"update_time_end"}]},
				{name:"创建人",id:"admin_username"},
				{name:"当前投放状态",id:"status",child:[{name:"已删除",id:"-1"},{name:"未发送",id:"0"},{name:"进行中",id:"1"},{name:"已完成",id:"2"}]},
			]
		},
		noticetemplate:{
			filterFields:[
				{name:"通知模板ID",id:"id"},
				{name:"通知标题",id:"title"},
				{name:'最近更新时间',type:"time",child:[{name:'最近更新时间(开始)',id:"update_time_start"},{name:'最近更新时间(结束)',id:"update_time_end"}]},
				{name:"通知触发场景说明",id:"condition"},
				{name:"通知内容",id:"content"},
				{name:"",type:"display"}
			]
		},
		holdAlltab:{
			filterFields:[
				{name:"用户ID",id:"open_id"},
				{name:"用户昵称",id:"username"},
				{name:'作品名称',id:"work_name"},
				{name:'注册时间',type:"time",child:[{name:'注册时间(开始)',id:'register_time_start'},{name:'注册时间(结束)',id:'register_time_end'}]},
				{name:'收益发放时间',type:"time",child:[{name:'收益发放时间(开始)',id:'issue_reward_time_start'},{name:'收益发放时间(结束)',id:'issue_reward_time_start'}]},
				{name:"",type:"display"}
			]
		},
		// 用户信息表-筛选
		item0Filter:{
			filterFields:[
				{name:"用户ID",id:"open_id"},
				{name:"用户昵称",id:"username"},
				{name:"手机号",id:"mobile"},
				{name:"注册时间",id:"create_at", type: "time",child:[{name:'注册时间',id:'create_time_start'},{name:'注册时间',id:'create_time_end'}]}
			]
		},
	},
	screenShow:{
		//用户基础信心展示字段筛选字段
		//、keyvalue，img,btn,two
		userBaseInfo:{
			bts:[
				{prop:'open_id',lable:'用户ID',width:150},
				{prop:'avatar',lable:'头像',type:"imgtou"},
				{prop:'username',lable:'昵称', width: 160},
				{prop:'mobile',lable:'手机号', width: 140},
				{prop:'email',lable:'邮箱', width: 180},
				{prop:'sex',lable:'性别',type:'keyvalue',child:{'1':"男","2":"女","0":"无"}},
				{prop:'vocation',lable:'职业'},
				{prop:'address',lable:'所在地',type:"address",child:["country","province","city"],width:"200"},
				{prop:'work_num',lable:'作品数量'},
				{prop:'fans_num',lable:'粉丝人数'},
				{prop:'shiquan_coin',lable:'狮币积分'},
				{prop:'weixin',lable:'主页-微信号',width:150,type:"nocon",name:"--"},
				{prop:'qq',lable:'主页-QQ号',width:150,type:"nocon",name:"--"},
				{prop:'create_time',lable:'注册时间', width: 180},
				{prop:'is_contributor',lable:'供稿人状态',width:200, type:'clFnd',clFnd(item) {
					if(item.is_contributor) {
						return item.contributor_type == 1 ? '个人认证' : '企业认证'
					}else {
						return '未认证'
					}
				}},
				{prop:'recommend_level',lable:'平台推荐评级',type:"novalue",width:150,novalue:"不推荐"},
				{prop:'commission_percent',lable:'拉新收益提成',type:"novalue",width:150},
				{prop:'commission_expire_time',lable:'默认提成有效期',type:"novalue",width:150},
				{prop:'referrer_username',lable:'推荐人昵称',type:"novalue",width:150},
				{prop:'referrer_id',lable:'推荐人ID',type:"novalue",width:150},
				{prop:'situation',lable:'工作状态',type:"novalue",width:150},
				{prop:'work_experience',lable:'每周可接单时间',type:"novalue",width:150},
				{prop:'preference_classify',lable:'项目类型偏好',type:"novalue",width:150},
				{prop:'design_experience',lable:'设计经验',type:"novalue",width:150},
			],
			defaults:[
				'avatar', 'username', 'mobile', 'email', 'sex', 'vocation', 'address', 'shiquan_coin',
				'work_num', 'fans_num', 'create_time', 'recommend_level', 'referrer_username'
			],
			action:{
				morebtns:{
					name:"更多",
					Ishow:true,
					child:[
						{
							name:"设为平台推荐创作者",
							accessid:"200710"
						},
						{
							name:"添加至黑名单",
							accessid:"200471"
						},
						{
							name:"修改拉新收益提成",
							accessid:"200711"
						}
					],
					page:'userBaseInfo'
				},
				links:{
					name:"查看",
					Ishow:true,
					accessid:"200042"
				}
			}
		},
		addrelease:{
			bts:[
				{prop:'open_id',lable:'用户ID',width:150},
				{prop:'avatar',lable:'用户头像',type:"imgtou"},
				{prop:'username',lable:'用户昵称',type:"url",id:"open_id",url:"/userManager/userBaseInfo/userBaseInfoDetail?open_id="},
				{prop:'sex',lable:'性别',type:'keyvalue',child:{'1':"男","2":"女","0":"无"}},
				{prop:'vocation',lable:'职位'},
				{prop:'address',lable:'所在地',type:"address",child:["country","province","city"],width:"200"},
				{prop:'personal_sign',lable:'个性签名'},
				{prop:'work_num',lable:'作品数量'},
				{prop:'follow_num',lable:'关注人数'},
				{prop:'fans_num',lable:'粉丝人数'},
				{prop:'education_school',lable:'学校名称'},
				{prop:'weixin',lable:'非认证-微信号',width:150,type:"nocon",name:"--"},
				{prop:'qq',lable:'非认证-QQ号',width:150,type:"nocon",name:"--"},
				{prop:'home_page',lable:'主页链接'},
				{prop:'weixin_name',lable:'授权认证-微信',width:150},
				{prop:'qq_name',lable:'授权认证-QQ',width:150},
				{prop:'create_time',lable:'注册时间'},
				{prop:'contributor_type',lable:'平台供稿人-认证状态',width:200,type:'keyvalue',child:{'1':"是","0":"否"}},
				{prop:'is_recommend',lable:'是否为平台推荐创作者',type:'keyvalue',child:{'1':"是","0":"否"}},
				{prop:'recommend_level',lable:'平台推荐等级',type:"novalue",width:150,novalue:"不推荐"},
				{name:"",type:"display"}
			],
			action:{
				is_hidden:true,
				morebtns:{
					page:"addrelease"
				}
			}
		},
		addblack:{
			bts0:[
				{prop:'open_id',lable:'用户ID',width:150},
				{prop:'avatar',lable:'用户头像',type:"imgtou"},
				{prop:'username',lable:'用户昵称',type:"url",id:"open_id",url:"/userManager/userBaseInfo/userBaseInfoDetail?open_id="},
				{prop:'sex',lable:'性别',type:'keyvalue',child:{'1':"男","2":"女","0":"无"}},
				{prop:'vocation',lable:'职位'},
				{prop:'address',lable:'所在地',type:"address",child:["country","province","city"],width:"200"},
				{prop:'personal_sign',lable:'个性签名'},
				{prop:'work_num',lable:'作品数量'},
				{prop:'follow_num',lable:'关注人数'},
				{prop:'fans_num',lable:'粉丝人数'},
				{prop:'education_school',lable:'学校名称'},
				{prop:'weixin',lable:'非认证-微信号',width:150,type:"nocon",name:"--"},
				{prop:'qq',lable:'非认证-QQ号',width:150,type:"nocon",name:"--"},
				// {prop:'home_page',lable:'主页链接'},
				{prop:'weixin_name',lable:'授权认证-微信',width:150},
				{prop:'qq_name',lable:'授权认证-QQ',width:150},
				{prop:'create_time',lable:'注册时间'},
				{prop:'contributor_type',lable:'平台供稿人-认证状态',width:200,type:'keyvalue',child:{'1':"是","0":"否"}},
				{prop:'is_recommend',lable:'是否为平台推荐创作者',type:'keyvalue',child:{'1':"是","0":"否"}},
				{prop:'recommend_level',lable:'平台推荐等级',type:"novalue",width:150,novalue:"不推荐"},
			],
			bts1:[
				{lable:"举报单ID",prop:"report_id",width:200},
				{lable:"举报者ID",prop:"open_id",width:200},
				{lable:"举报者昵称",prop:"username",width:200},
				{lable:"举报类型",prop:"classify_name",width:200},
				{lable:"举报对象ID",prop:"accused_open_id",width:200},
				{lable:"举报对象昵称",prop:"accused_username",width:200},
				{lable:"举报位置",prop:"position",type:"keyvalue",child:{work:"作品举报",comment:"评论举报",user:"用户中心举报",message:"私信举报"}},
				{lable:"详细说明",prop:"detail",width:200},
				{lable:"提交时间",prop:"create_time",width:200},
			],

			action:{
				is_hidden:true,
				morebtns:{
					page:"addblack"
				}
			},
			page:"addblack"
		},
		userCompanyInfo:{
			bts:[
				{prop:'open_id',lable:'用户ID',width:200},
				{prop:'username',lable:'用户昵称'},
				{prop:'mobile',lable:'手机号',width:200},
				{prop:'email',lable:'邮箱',width:200},
				{prop:'company_name',lable:'企业/机构名称',width:150},
				{prop:'code',lable:'统一信用代码（企业）',width:200},
				{prop:'business_license',lable:'营业执照',type:"img",width:200},
			],
			action:{
				morebtns:{
					name:"更多",
					Ishow:false,
					page:'userCompanyInfo'
				},
				links:{
					name:"查看详情",
					Ishow:true,
					accessid:"200052"
				},

			}
		},
		userPersonalInfo:{
			bts:[
				{prop:'open_id',lable:'用户ID',width:200},
				{prop:'username',lable:'用户昵称'},
				{prop:'mobile',lable:'手机号'},
				{prop:'email',lable:'邮箱'},
				{prop:'name',lable:'身份证姓名'},
				{prop:'id_card',lable:'身份证号码'},
				{prop:'front_photo',lable:'身份证照片',type:"img",width:200},
			],
			action:{
				morebtns:{
					name:"更多",
					Ishow:false,
					page:"userPersonalInfo"
				},
				links:{
					name:"查看详情",
					Ishow:true,
					accessid:"200047"
				},

			}
		},
		roleManager:{
			bts:[
				{prop:'id',lable:'角色ID'},
				{prop:'name',lable:'角色名称'},
				{prop:'description',lable:'角色介绍'},
				{prop:'bind_user_num',lable:'绑定账号数'},
				{prop:'created_at',lable:'创建时间'},
			],
			action:{
				morebtns:{
					name:"更多",
					Ishow:true,
					child:[
						{
							name:"编辑",
							accessid:"200059"

						},
						{
							name:"删除",
							accessid:"200060"
						}
					],
					page:"roleManager"
				},
				links:{
					name:"查看",
					Ishow:true,
					accessid:"200057"
				},
				page:'roleManager'
			}
		},
		newlistAd:{
			bts:[
				{prop:'work_id',lable:'作品ID'},
				{lable:"作品名称",prop:"work_name",type:"url",id:"work_id",url:"/workManager/workInfo/workInfoDetial?id="},
				{prop:'face_pic',lable:'封面图',type:"img",width:150},
				{prop:'username',lable:'用户昵称',type:"url",id:"open_id",url:"/userManager/userBaseInfo/userBaseInfoDetail?open_id="},
				{prop:'classify',lable:'作品类型'},
				{prop:'recommend_level',lable:'平台推荐评级'},
				{prop:'is_platform_work',lable:'是否为平台投稿作品'},
				{prop:'is_hired',lable:'是否为录用作品'},

			],
			action:{
				morebtns:{
					name:"更多",
					Ishow:false,
					page:"newrecommendedActivities",
					filterField:["0","1"],
					child:[
						{
							name:"删除",
							filterField:["0"],
							id:"top0"
						},
						{
							name:"编辑",
							filterField:["0","1"],
							id:"top1"
						},
					],
				},
				links:{
					name:"选择",
					Ishow:true
				}
			}
		},
		accountManager:{
			bts:[
				{prop:'id',lable:'账户ID'},
				{prop:'name',lable:'账户名'},
				{prop:'email',lable:'邮箱'},
				{prop:'role_name',lable:'权限角色'},
				{prop:'created_at',lable:'创建时间'},
				{prop:'updated_at',lable:'更新时间'},
			],
			action:{
				morebtns:{
					name:"设置角色",
					Ishow:true,
					page:"accountManager",
					accessid:"200064"
				},
				links:{
					name:"查看",
					Ishow:true,
					accessid:"200062"
				}
			}
		},
		publishWork:{
			bts:[
				{prop:'work_id',lable:'作品ID'},
				{prop:'face_pic',lable:'作品封面', type:"hover-img"},
				{lable:"作品标题",prop:"work_name",type:"url",id:"work_id",url:"/workManager/workInfo/workInfoDetial?id="},
				{prop:'open_id',lable:'提审用户ID',width:200},
				{prop:'username',lable:'用户昵称',type:"hiretime",url:"/userManager/userBaseInfo/userBaseInfoDetail?open_id=",id:'open_id',time:"create_time",width:200},
				{prop:'is_ai_checked',lable:'AI审核状态',type:"multistate",child:{"0":"待处理","1":"处理中","2":"通过","-1":"不通过"},
					text_color_name:'is_ai_checked',
                    text_color:(val)=>{
                        switch(val) {
                            case '0':
                                return '#2fafd9'
                            case '1':
                                return '#d9c92f'
                            case '2':
                                return '#67C239'
                            case '-1':
                                return '#f55553'
                            default:
                                // 默认代码块
                                return val
                        } 
                    }
				},
				{prop:'check_status',lable:'审核状态',type:"btn",child:{"0":"待审核","1":"审核通过","-1":"审核驳回","-2":"失效或撤回"}},
				{prop:'check_admin_name',lable:'审核人',type:"hiretime1",time:"check_time",width:200},
			],
			action:{
				morebtns:{
					name:"设置角色",
					Ishow:false,
					page:"publishWork",

				},
				links:{
					name:"详情",
					Ishow:true,
					accessid:"200077"
				}
			},
		},
		finalistsWork:{
			bts:[
				{prop:'work_id',lable:'作品ID'},
				{lable:"作品标题",prop:"work_name",type:"url",id:"work_id",url:"/workManager/workInfo/workInfoDetial?id="},
				{prop:"activity_id",lable:"活动ID"},
				{lable:"活动标题",prop:"activity_name",type:"url1",id:"activity_id",url:"/#/conts?id="},
				{prop:'open_id',lable:'提审用户ID',width:200},
				{prop:'username',lable:'用户昵称',type:"hiretime",url:"/userManager/userBaseInfo/userBaseInfoDetail?open_id=",id:'open_id',time:"create_time",width:200},
				{prop:'check_status',lable:'审核状态',type:"btn",child:{"0":"待审核","1":"审核通过","-1":"审核驳回","-2":"失效或撤回"},width:350},
				{prop:'check_admin_name',lable:'审核人',type:"hiretime1",time:"check_time",width:200},
			],
			action:{
				morebtns:{
					name:"设置角色",
					Ishow:false,
					page:"finalistsWork"
				},
				links:{
					name:"详情",
					Ishow:true,
					accessid:"200082"
				}
			},
		},
		employWork:{
			bts:[
				{prop:'id',lable:'审核ID'},
				{prop:'work_id',lable:'作品ID'},
				{lable:"作品标题",prop:"work_name",type:"url",id:"work_id",url:"/workManager/workInfo/workInfoDetial?id="},
				{prop:"activity_id",lable:"活动ID"},
				{lable:"活动标题",prop:"activity_name",type:"url1",id:"activity_id",url:"/#/conts?id="},
				{prop:'open_id',lable:'提审用户ID',width:200},
				{prop:'username',lable:'用户昵称',type:"hiretime",url:"/userManager/userBaseInfo/userBaseInfoDetail?open_id=",id:'open_id',time:"create_time",width:200},
				{prop:'check_status',lable:'审核状态',type:"btn",child:{"0":"待审核","1":"审核通过","-1":"审核驳回","-2":"失效或撤回"},width:350},
				{prop:'check_admin_name',lable:'审核人',type:"hiretime1",time:"check_time",width:200},
			],
			action:{
				morebtns:{
					name:"设置角色",
					Ishow:false,
					page:"employWork"
				},
				links:{
					name:"详情",
					Ishow:true,
					accessid:"200087"
				}
			},
		},
		projectreview:{
			bts:[
				{prop:'id',lable:'审核ID'},
				{prop:'project_id',lable:'项目ID'},
				{prop:'name',lable:'项目名称'},
				{prop:'classify_name',lable:'项目类型',},
				{lable:"稿件预览图",prop:"preview_pic",type:"img",width:270},
				{prop:'business_type',lable:'业务类型',type:"keyvalue",child:window.ywArr2},
				{prop:{prop1:"file_name",prop2:"online_disk_url"},type:"urlfile",filetype:{name:"type",id:'1'},lable:'交稿文件/网盘链接'},
				{prop:'remark',lable:'备注说明',width:350},
				{prop:'username',lable:'提审用户昵称'},
				{prop:'check_status',lable:'审核状态',type:"btn",child:{"0":"待审核","1":"审核通过","-1":"审核驳回","-2":"失效或撤回"},width:350},
				{prop:'admin_name',lable:'审核人',type:"hiretime1",time:"check_time",width:200},
			],
			action:{
				morebtns:{
					name:"设置角色",
					Ishow:false,
					page:"projectreview"
				},
				links:{
					name:"详情",
					Ishow:true,
					// accessid:"200510"
				}
			},
		},
		applyPerson:{
			bts:[
				{prop:'id',lable:'审核ID'},
				{prop:'contributor_type',lable:'账号主体',type:"keyvalue",child:{"1":"个体","2":"企业"}},
				{prop:'check_type',lable:'提交类型',type:"keyvalue",child:{"1":"初次申请","2":"驳回复审申请","3":"修改信息申请"}},
				{prop:'open_id',lable:'提审用户ID',width:200},
				{prop:'username',lable:'用户昵称',type:"hiretime",url:"/userManager/userBaseInfo",time:"create_time",width:200},
				{prop:'check_status',lable:'审核状态',type:"btn",child:{"0":"待审核","1":"审核通过","-1":"审核驳回","-2":"失效或撤回"},width:350},
				{prop:'check_admin_name',lable:'审核人',type:"hiretime1",time:"check_time",width:200},
			],
			action:{
				morebtns:{
					name:"设置角色",
					Ishow:false,
					page:"applyPerson"
				},
				links:{
					name:"详情",
					Ishow:true,
					accessid:"200092"
				}
			},
		},
		workInfo:{
			defaults:["work_id","work_name","face_pic","username","classify","is_platform_work","is_hired","hire_type","status"],
			bts:[
				{prop:'work_id',lable:'作品ID',width:200},
				{prop:'work_name',lable:'作品标题',width:200},
				{prop:'face_pic',lable:'封面图',type:"img",width:150},
				{prop:'open_id',lable:'用户ID'},
				{prop:'username',lable:'用户昵称',type:"url",id:"open_id",url:"/userManager/userBaseInfo/userBaseInfoDetail?open_id="},
				{prop:'avatar',lable:'用户头像',type:"imgtou"},
				{prop:'classify',lable:'作品类型',width:200},
				{prop:'copyright',lable:'版权说明'},
				{prop:'labels',lable:'作品标签'},
				{prop:'is_platform_work',lable:'是否为平台投稿作品',width:200,type:"keyvalue",child:{"0":"否","1":"是"}},
				{prop:'is_hired',lable:'是否已被录用',width:200,type:"keyvalue",child:{"0":"否","1":"是"}},
				{prop:'hire_type',lable:'录用方式',type:"keyvalue",child:{"1":"买断式","2":"分成式","no":"未录用"}},
				{prop:'activity_id',lable:'录用活动ID'},
				{prop:'activity_name',lable:'录用活动名称'},
				{prop:'hire_id',lable:'录用订单ID'},
				{prop:'hire_order_name',lable:'录用订单名称',width:200},
				{prop:'http://dev-shiquaner.idatachain.cn/#/conts?id=',lable:'作品预览链接',type:"urlopen",width:200},
				// {prop:'status',lable:'当前状态',type:"statustwo",child:{
				// 	is_del:{"1":"用户删除","2":"系统下架"},
				// 	status:{"0":"待审核","1":"审核中","2":"审核通过","-1":"草稿","-2":"未通过"}
				// },width:150}
			],
			action:{
				morebtns:{
					name:"更多",
					Ishow:true,
					page:"workInfo",
					child:[
						{
							name:"预览",
							accessid:"200305"
						},
						{
							name:"下架",
							accessid:"200461"
						},
						{
							name:"录用",
							accessid:"200462"
						},
						{
							name:"修改平台推荐等级",
							accessid:"200463"
						},
						{
							name:"绑定补充合同",
							accessid:"200464"
						}
					],
				},
				links:{
					name:"查看",
					Ishow:true,
					accessid:"200305"
				}
			},
		},
		worksShelves:{
			bts:[
				{lable:"举报单ID",prop:"report_id",width:200},
				{lable:"举报者ID",prop:"open_id",width:200},
				{lable:"举报者昵称",prop:"username",width:200},
				{lable:"举报类型",prop:"classify_name",width:200},
				{lable:"举报对象ID",prop:"accused_open_id",width:200},
				{lable:"举报对象昵称",prop:"accused_username",width:200},
				{lable:"举报位置",prop:"position",type:"keyvalue",child:{work:"作品举报",comment:"评论举报",user:"用户中心举报",message:"私信举报"}},
				{lable:"详细说明",prop:"detail",width:200},
				{lable:"提交时间",prop:"create_time",width:200},
			],
			action:{
				is_hidden:true,
				morebtns:{
					page:"worksShelves"
				}
			}
		},
		commentManager:{
			defaults:['comment_id','open_id','username','content','to_open_id','type','create_time'],
			bts:[
				{prop:'comment_id',lable:'评论回复ID'},
				{prop:'open_id',lable:'用户ID',width:200},
				{lable:"用户名称",prop:"username",type:"url",id:"open_id",url:"/userManager/userBaseInfo/userBaseInfoDetail?open_id="},
				{prop:'avatar',lable:'用户头像',type:"imgtou"},
				{prop:'work_id',lable:'作品ID'},
				{prop:'type',lable:'发言类型',type:"keyvalue",child:{"1":"评论","2":"回复"}},
				{prop:'content',lable:'发言内容',width:150},
				{prop:'to_open_id',lable:'评论/回复 对象（用户ID）',width:200},
				{prop:'create_time',lable:'发言时间'}
			],
			action:{
				morebtns:{
					name:"更多",
					Ishow:false,
					page:"commentManager",
					child:[
						{
							name:"预览"
						},
						{
							name:"下架"
						},
						{
							name:"录用"
						},
						{
							name:"修改平台推荐等级"
						},

					],
				},
				links:{
					name:"删除",
					Ishow:true,
					accessid:"200323"
				},
			}
		},
		activityClass:{
			bts:[
				{prop:'id',lable:'主题分类ID',width:200},
				{prop:'category_name',lable:'主题分类名称',width:150},
				{prop:'processing_activity_num',lable:'进行中活动数'},
				{prop:'updated_at',lable:'更新时间'},
				{prop:'status',lable:'当前状态',type:"status",child:{"1":"启用","0":"停用"},statusclass:"presetReasonstatus"}
			],
			action:{
				morebtns:{
					name:"更多",
					Ishow:false,
					page:"activityClass",
					child:[


					],
				},
				links:{
					name:"修改",
					Ishow:true,
					filterField:[0],
					accessid:"200332"
				},
				pagefilterField:true,
				pagefilterFieldid:"processing_activity_num"

			}
		},
		labels:{
			bts:[
				{prop:'label',lable:'标签词'},
				{prop:'count',lable:'作品标注数'}
			],
			action:{
				is_hidden:true,
				morebtns:{
					page:"labels"
				}
			}
		},
		settlement:{
			bts:[
				{prop:"work_id",lable:"项目ID"},
				{prop:"name",lable:"项目名称"},
				{prop:"balance_date",lable:"结算周期"},
				{prop:"open_id",lable:"用户ID"},
				{prop:"username",lable:"用户昵称"},
				{prop:"deal_type",lable:"结算方式",type:"keyvalue",child:{"1":"买断","2":"分成","3":"预付金+分成"}},
				{prop:"primary_fee",lable:"纯分成金额",type:"price"},
				{prop:"gain_share_rate",lable:"收益加成比",type:"baifen"},
				{prop:"profit_fee",lable:"加成金额",type:"price"},
				{prop:"balance_fee",lable:"分成结算收益",type:"price"},
				{prop:"advance_payment",lable:"预付金额",type:"price"},
				{prop:"advance_payment_income",lable:"预付金收益",type:"price"},
				{prop:"advance_payment_total_income",lable:"预付金累计",type:"price"},
			],
			action:{
				is_hidden:true,
				morebtns:{
					page:"settlement"
				}
			}
		},
		activityEmploy:{
			bts:[
				{prop:'id',lable:'活动ID'},
				{prop:'activity_name',lable:'活动名称'},
				{prop:'banner',lable:'banner',type:"img",width:200},
				{prop:'category_name',lable:'主题分类'},
				{prop:"sort_weight",lable:"排序权重"},
				{prop:'time',type:"merge",lable:'活动时间',child:{id1:"start_time",id2:"end_time"},width:320},
				{prop:'status',lable:'当前状态',width:150,type:"status",child:{"0":"未开始","1":"进行中","-1":"已结束"},statusclass:"activityEmploystatus"},
				{prop:'setting_type',lable:'作品上传和展示',type:"keyvalue",width:250,child:{"1":"不支持上传","2":"支持上传，不支持展示作品","3":"支持上传，仅展示入围作品","4":"支持上传，并展示入围和录用作品"}},
				{prop:'shortlisted_num',lable:'入围作品数量',width:250},
				{prop:'hire_num',lable:'录用作品数量',width:250},
			],
			action:{
				morebtns:{
					name:"更多",
					Ishow:true,
					page:"activityEmploy",
					filterField:["0","1"],
					child:[
						{
							name:"删除",
							filterField:['1'],
							id:"top0",
							accessid:"200328"
						},
						{
							name:"编辑",
							filterField:["0","1"],
							id:"top1",
							accessid:"200327"
						}
					],
				},
				delete:{
					name:"删除",
					Ishow:true
				},
				links:{
					name:"预览",
					Ishow:true
				},
				pagefilterField:true,
				pagefilterFieldid:"status"
			}
		},

		newrecommendedActivities:{
			bts:[
				{prop:'id',lable:'活动ID'},
				{prop:'activity_name',lable:'活动名称'},
				{prop:'banner',lable:'banner',type:"img",width:200},
				{prop:'category_name',lable:'主题分类'},
				{prop:'time',type:"merge",lable:'活动时间',child:{id1:"start_time",id2:"end_time"},width:320},
				{prop:'status',lable:'当前状态',width:150,type:"status",child:{"0":"未开始","1":"进行中","-1":"已结束","-2":"已删除"}},
				{prop:'setting_type',lable:'作品上传和展示',type:"keyvalue",width:250,child:{"1":"不支持上传","2":"支持上传，不支持展示作品","3":"支持上传，仅展示入围作品","4":"支持上传，并展示入围和录用作品"}},
				{prop:'shortlisted_num',lable:'入围作品数量',width:250},
				{prop:'hire_num',lable:'录用作品数量',width:250},
			],
			action:{
				morebtns:{
					name:"更多",
					Ishow:false,
					page:"newrecommendedActivities",
					filterField:["0","1"],
					child:[
						{
							name:"删除",
							filterField:["0"],
							id:"top0"
						},
						{
							name:"编辑",
							filterField:["0","1"],
							id:"top1"
						}
					],
				},
				links:{
					name:"选择",
					Ishow:true,
					filterField:["0"],
				},

			}
		},

		activityworks:{
			defaults:['work_id','work_name','activity_id','activity_name','open_id','username','status_msg'],
			bts:[
				{lable:"作品ID",prop:"work_id"},
				{lable:"作品名称",prop:"work_name",type:"url",id:"work_id",url:"/workManager/workInfo/workInfoDetial?id="},
				{lable:"活动ID",prop:"activity_id"},
				{lable:"活动名称",prop:"activity_name",type:"url1",id:"activity_id",url:"/#/conts?id="},
				{lable:"用户ID",prop:"open_id"},
				{lable:"用户名称",prop:"username",type:"url",id:"open_id",url:"/userManager/userBaseInfo/userBaseInfoDetail?open_id="},
				{prop:'avatar',lable:'用户头像',type:"imgtou"},
				{lable:"作品封面图",prop:"face_pic",type:"img",width:200},
				{lable:"活动banner",prop:"banner"},
				{lable:"入围时间",prop:"shortlisted_time"},
				{lable:"录用时间",prop:"hire_time"},
				{lable:"当前状态",prop:"status_msg"},
			],
			action:{
				morebtns:{
					name:"更多",
					Ishow:false,
					page:"activityworks",
					child:[
						{
							name:"删除",
							accessid:"200343"
						},
						{
							name:"编辑",
							accessid:"200342"
						}
					],
				},
				links:{
					name:"预览",
					Ishow:true,
					accessid:"200335"
				},
			}
		},
		solicitationTemplate:{
			bts1:[
				{lable:"模板文件ID",prop:"template_file_id"},
				{lable:"文件名称",prop:"file_name"},
				{lable:"网盘链接",prop:"online_disk_info"},
				{lable:"在用活动数",prop:"processing_activity_num"},
				{lable:"上传人",prop:"admin_name"},
				{lable:"更新时间",prop:"updated_at"},
				{lable:"上传时间",prop:"created_at"}
			],
			bts0:[
				{lable:"模板文件ID",prop:"template_file_id"},
				{lable:"文件名称",prop:"file_name"},
				{lable:"文件格式",prop:"file_type"},
				{lable:"文件大小",prop:"file_size_format"},
				{lable:"在线活动数",prop:"processing_activity_num"},
				{lable:"上传人",prop:"admin_name"},
				{lable:"模板地址",prop:"template_url", width: "300px"},
				{lable:"上传时间",prop:"created_at"}
			],
			action0:{
				morebtns:{
					name:"更多",
					Ishow:true,
					page:"solicitationTemplate",
					child:[
						{
							name:"修改文件名",
							accessid:"200443"
						},
						{
							name:"删除",
							accessid:"200444"
						},
						{
							name:"下载",
							accessid:"200449"
						},
					],
				},
				links:{
					name:"预览",
					Ishow:false
				},
			},
			action1:{
				morebtns:{
					name:"更多",
					Ishow:true,
					page:"solicitationTemplate",
					child:[
						{
							name:"修改文件名",
							accessid:"200446"
						},
						{
							name:"删除",
							accessid:"200447"
						}
					],
				},
				links:{
					name:"预览",
					Ishow:false
				},
			}
		},
		newActivity:{
			bts1:[
				{type:"radio",prop:"template_file_id"},
				{lable:"模板文件ID",prop:"template_file_id"},
				{lable:"文件名称",prop:"file_name"},
				{lable:"网盘链接",prop:"online_disk_info"},
				{lable:"在用活动数",prop:"processing_activity_num"},
				{lable:"上传人",prop:"admin_name"},
				{lable:"更新时间",prop:"updated_at"},
				{lable:"上传时间",prop:"created_at"}
			],
			bts0:[
				{type:"radio",prop:"template_file_id"},
				{lable:"模板文件ID",prop:"template_file_id"},
				{lable:"文件名称",prop:"file_name"},
				{lable:"文件格式",prop:"file_type"},
				{lable:"文件大小",prop:"file_size_format"},
				{lable:"在线活动数",prop:"processing_activity_num"},
				{lable:"上传人",prop:"admin_name"},
				{lable:"更新时间",prop:"updated_at"},
				{lable:"上传时间",prop:"created_at"}
			],
			action:{
				is_hidden:true,
				morebtns:{ page:"newActivity" }
			}
		},
		homeBanner:{
			bts:[
				{lable:"banner素材ID",prop:"id"},
				{lable:"banner素材名称",prop:"banner_name"},
				{lable:"banner图片",prop:"banner_pic",type:"img",width:200},
				{lable:"跳转链接",prop:"jump_url",type:"url"},
				{lable:"创建时间",prop:"create_time"},
				{lable:"当前状态",prop:"status",type:"status",statusclass:"recommendedActivitiesstatus",child:{"1":"待使用","0":"未使用","2":"线上展示中"}}
			],
			action:{
				morebtns:{
					name:"删除",
					Ishow:true,
					page:"homeBanner",
					accessid:"200440"
				},
				links:{
					name:"修改",
					Ishow:true,
					accessid:"200439"
				},
			}
		},
		addbannerScheme:{
			bts:[
				{lable:"banner素材ID",prop:"id"},
				{lable:"banner素材名称",prop:"banner_name"},
				{lable:"banner图片",prop:"banner_pic",type:"img",width:200},
				{lable:"跳转链接",prop:"jump_url",type:"url"},
				{lable:"创建时间",prop:"create_time"},
				{lable:"当前状态",prop:"status",type:"status",statusclass:"recommendedActivitiesstatus",child:{"1":"待使用","0":"未使用","2":"线上展示中"}}
			],
			action:{
				morebtns:{
					name:"删除",
					Ishow:false,
					page:"addbannerScheme",
				},
				links:{
					name:"选择",
					Ishow:true
				},
			}
		},
		hotWordSearch:{
			bts:[
				{lable:"任务ID",prop:"id"},
				{lable:"调文案",prop:"word"},
				{lable:"干预位置",prop:"position",type:"keyvalue",child:{"1":"第一位","2":"第二位","3":"第三位","4":"第四位", "5":"第五位"}},
				{prop:'time',type:"merge",lable:'干预时间',child:{id1:"start_time",id2:"end_time"},width:320},
				{lable:"当前状态",prop:"status",type:"status",statusclass:"recommendedActivitiesstatus",child:{"1":"线上展示中","0":" 未开始","-1":"已过期","-2":"已删除"}}
			],
			action:{
				morebtns:{
					name:"删除",
					Ishow:true,
					page:"hotWordSearch",
					accessid:"200075"
				},
				links:{
					name:"编辑",
					Ishow:true,
					accessid:"200074"
				},
			}
		},
		serviceCenter:{
			bts:[
				{lable:"文档ID",prop:"id"},
				{lable:"文档备注",prop:"remark"},
				{lable:"文档类型",prop:"type",type:"keyvalue",child:{"1":"关于我们","2":"用户协议","3":"授权协议","4":"帮助中心","5":"常见问题","6":"来电秀app工具","7":"狮映-用户协议","8":"狮映-供稿人协议","9":"锁屏工具-用户协议"}},
				{lable:'更新时间',prop:"updated_at"},
				{lable:"当前状态",prop:"status",type:"status",statusclass:"recommendedActivitiesstatus",child:{"1":"线上展示中","0":" 未开始","-1":"已过期","-2":"已删除"}}
			],
			action:{
				morebtns:{
					name:"更多",
					Ishow:true,
					page:"serviceCenter",
					child:[
						{
							name:"编辑",
							accessid:"200352",
						},
						{
							name:"删除",
							accessid:"200353"
						},
						{
							name:"设为线上展示",
							accessid:"200352"
						}
					]
				},
				links:{
					name:"预览",
					Ishow:true
				},
			}
		},
		recommendedActivities:{
			bts:[
				{lable:"任务ID",prop:"id"},
				{lable:"干预活动",prop:"activity_name",type:"url1",id:"activity_id",url:"/#/conts?id="},
				{lable:"干预位置",prop:"position",type:"keyvalue",child:{"1":"第一位","2":"第二位","3":"第三位","4":"第四位"}},
				{prop:'time',type:"merge",lable:'干预时间',child:{id1:"start_time",id2:"end_time"},width:320},
				{lable:"当前状态",prop:"status",type:"status",statusclass:"recommendedActivitiesstatus",child:{"1":"线上展示中","0":" 未开始","-1":"已过期","-2":"已删除"}}
			],
			action:{
				morebtns:{
					name:"删除",
					Ishow:true,
					page:"recommendedActivities",
					accessid:"200348"
				},
				links:{
					name:"编辑",
					Ishow:true,
					accessid:"200347"
				},
			}
		},
		listAd:{
			bts:[

				{lable:"任务ID",prop:"id"},
				{lable:"作品ID",prop:"work_id"},
				{lable:"作品名称",prop:"work_name",type:"url",id:"work_id",url:"/workManager/workInfo/workInfoDetial?id="},
				{lable:"干预位置",prop:"position"},
				{prop:'time',type:"merge",lable:'干预时间',child:{id1:"start_time",id2:"end_time"},width:320},
				{lable:"当前状态",prop:"status",type:"status",statusclass:"recommendedActivitiesstatus",child:{"1":"线上展示中","0":" 未开始","-1":"已过期","-2":"已删除"}}
			],
			action:{
				morebtns:{
					name:"删除",
					Ishow:true,
					page:"listAd",
					accessid:"200422"
				},
				links:{
					name:"编辑",
					Ishow:true,
					accessid:"200423"
				},
			}
		},
		employmentorder:{
			defaults:['order_id','hire_order_name','work_id','work_name','open_id','hire_type',"username","price"],
			bts:[
				{lable:"录用订单ID",prop:"order_id"},
				{lable:"订单名称",prop:"hire_order_name"},
				{lable:"作品ID",prop:"work_id"},
				{lable:"作品名称",prop:"work_name",type:"url",id:"work_id",url:"/workManager/workInfo/workInfoDetial?id="},
				{lable:"用户ID",prop:"open_id"},
				{lable:"用户名称",prop:"username",type:"url",id:"open_id",url:"/userManager/userBaseInfo/userBaseInfoDetail?open_id="},
				{lable:"录用方式",prop:"hire_type",type:"keyvalue",child:{"1":"买断式","2":"分成式"}},
				{lable:"录用价格及评估值",prop:"price",type:"price"},
			],
			action:{
				morebtns:{
					name:"预览",
					Ishow:true,
					page:"employmentorder",
					accessid:"200355"
				},
				links:{
					name:"详情",
					Ishow:true,
					accessid:"200355"
				},
			}
		},
		channel:{
			defaults:['order_id','hire_order_name','work_id','work_name','open_id','hire_type','status',"username","hire_time"],
			bts:[
				{lable:"分成渠道ID",prop:"ids"},
				{lable:"录用订单ID",prop:"order_id"},
				{lable:"作品ID",prop:"work_id"},
				{lable:"用户ID",prop:"open_id"},
				{lable:"子渠道ID",prop:"ids"},
				{lable:"广告位ID",prop:"ids"},
				{lable:"广告位名称",prop:"ids"},
				{lable:"投放渠道",prop:"ids"},
				{lable:"分成指标",prop:"ids"},
				{lable:"分成单价",prop:"ids"},
				{lable:"展示量",prop:"ids"},
				{lable:"结算收益",prop:"ids"},
				{lable:"当前状态",prop:"ids",type:"status",child:{"1":"待结算","0":"已结算"}},
				{lable:"最近更新时间",prop:"ids"},
			],
			action:{
				morebtns:{
					name:"预览",
					Ishow:false,
					page:"employmentorder",
				},
				links:{
					name:"详情",
					Ishow:false
				},
			}
		},
		embodyRecord:{
			bts:[
				{lable:"提现ID",prop:"apply_id"},
				{lable:"提现用户ID",prop:"open_id"},
				{prop:'username',lable:'用户昵称',type:"url",id:"open_id",url:"/userManager/userBaseInfo/userBaseInfoDetail?open_id="},
				{lable:"提现金额",prop:"cash_money",type:"price"},
				{lable:"账号主体",prop:"contributor_type",type:"keyvalue",child:{"1":"个人","2":"企业"}},
				{lable:"状态",prop:"check_status",type:"status",child:{"0":"待审核","1":"审核中","2":"审核通过","3":"已付款","-1":"审核不通过","-2":"申请已撤销"}},
				{lable:"处理时间",prop:"check_time"},
				{lable:"申请时间",prop:"apply_time"},
			],
			action:{
				morebtns:{
					name:"预览",
					Ishow:false,
					page:"embodyRecord",
				},
				links:{
					name:"查看",
					Ishow:true,
					accessid:"200365"
				},
			}
		},
		presetReason:{
			bts:[
				{lable:"驳回理由预设ID",prop:"id"},
				{lable:"审核类型",prop:"type",type:"keyvalue",child:{"1":"作品发布","2":"作品入围","3":"作品审核","4":"平台供稿人-认证申请","5":"项目验收","6":"项目报名", "8":"摄影交稿","10":"渠道分发"}},
				{lable:"驳回理由",prop:"content"},
				{lable:"状态",prop:"status",type:"status",child:{"0":"停用","1":"启用"},statusclass:"presetReasonstatus"},
				{lable:"该理由驳回数",prop:"reject_num"},
				{lable:"创建时间",prop:"created_at"}
			],
			action:{
				morebtns:{
					name:"删除",
					Ishow:true,
					page:"presetReason",
					accessid:"200373"
				},
				links:{
					name:"停用",
					Ishow:true,
					child:{"0":"启用","1":"停用"},
					accessid:"200372"

				},
			}
		},
		feedback:{
			bts0:[
				{lable:"反馈单ID",prop:"feedback_id"},
				{lable:"用户ID",prop:"open_id"},
				{prop:'username',lable:'用户昵称',type:"url",id:"open_id",url:"/userManager/userBaseInfo/userBaseInfoDetail?open_id="},
				{lable:"截图",prop:"pic",type:"img",width:200},
				{lable:"问题类型",prop:"classify_name"},
				{lable:"问题描述",prop:"detail"},
				{lable:"联系方式类型",prop:"link_type"},
				{lable:"联系方式",prop:"link"},
				{lable:"提交时间",prop:"create_time"},

			],
			bts1:[
				{lable:"问题类型ID",prop:"id"},
				{lable:"类型名称",prop:"classify_name"},
				{lable:"状态",prop:"status",type:"status",child:{"1":"启用","0":"停用","-1":"删除"},statusclass:"presetReasonstatus"},
				{lable:"该类型反馈数",prop:"used_num"},
				{lable:"创建时间",prop:"create_time"},
			],
			action1:{
				morebtns:{
					name:"删除",
					Ishow:true,
					page:"feedback",
					accessid:"200430"
				},
				links:{
					name:"停用",
					Ishow:true,
					child:{"0":"启用","1":"停用"},
					accessid:"200431"
				},
			},
			action0:{
				morebtns:{
					name:"删除",
					Ishow:false,
					page:"feedback",
				},
				links:{
					name:"查看",
					Ishow:true,
					accessid:"200426"
				},
				hf_links:{
					name:"回复",
					Ishow:true,
					accessid:""
				},
			}
		},
		reportInfo:{
			bts0:[
				{lable:"举报单ID",prop:"report_id"},
				{lable:"举报者ID",prop:"open_id"},
				{lable:"举报者昵称",prop:"username"},
				{lable:"举报类型",prop:"classify_name"},
				{lable:"举报对象ID",prop:"accused_open_id"},
				{lable:"举报对象昵称",prop:"accused_username"},
				{lable:"举报位置",prop:"position",type:"keyvalue",child:{work:"作品举报",comment:"评论举报",user:"用户中心举报",message:"私信举报"}},
				{lable:"详细说明",prop:"detail"},
				{lable:"提交时间",prop:"create_time"},

			],
			bts1:[
				{lable:"问题类型ID",prop:"id"},
				{lable:"分类名称",prop:"classify_name"},
				{lable:"状态",prop:"status",type:"status",child:{"1":"启用","0":"停用"},statusclass:"presetReasonstatus"},
				{lable:"该分类举报数",prop:"used_num"},
				{lable:"创建时间",prop:"created_at"},
			],
			action1:{
				morebtns:{
					name:"删除",
					Ishow:true,
					page:"reportInfo",
					accessid:"200457"
				},
				links:{
					name:"停用",
					Ishow:true,
					child:{"0":"启用","1":"停用"},
					accessid:"200458"
				},
			},
			action0:{
				morebtns:{
					name:"删除",
					Ishow:false,
					page:"reportInfo",
				},
				links:{
					name:"查看",
					Ishow:true,
					accessid:"200456"
				},
			}
		},
		newsRelease:{
			bts:[
				{lable:"通知ID",prop:"id"},
				{lable:"通知标题",prop:"title"},
				{lable:"预发用户数",prop:"send_num"},
				{lable:"发送完成时间",type:"merge",child:{id1:"send_start_time",id2:"send_end_time"},is_hidden:{
					"name":"status",
					"value":"0"
				},width:320},
				{lable:"当前状态",prop:"status",type:"status",child:{"0":"未发送","1":"进行中","2":"已完成"},statusclass:"newsReleasestatus"},
				{lable:"发送成功数",prop:"send_num",is_hidden:{
					"name":"status",
					"value":"0",
					"namevalue":"0"
				}},
				{lable:"创建人",prop:"admin_username"},
			],
			action:{
				morebtns:{
					name:"删除",
					Ishow:true,
					page:"newsRelease",
					accessid:"200388"
				},
				links:{
					name:"编辑",
					Ishow:true,
					accessid:"200387"
				},
			}
		},
		noticetemplate:{
			bts:[
				{lable:"通知模板ID",prop:"id"},
				{lable:"通知标题",prop:"title"},
				{lable:"通知触发场景说明",prop:"condition"},
				{lable:"通知内容",prop:"content"},
				{lable:"最近更新时间",prop:"updated_at"},
			],
			action:{
				is_hidden:true,
				morebtns:{
					page:"noticetemplate"
				}
			}
		},
		holdAlltab:{
			bts:[
				{lable:"用户ID",prop:"open_id",width:200},
				{prop:'username',lable:'用户昵称',type:"url",id:"open_id",url:"/userManager/userBaseInfo/userBaseInfoDetail?open_id="},
				{lable:"作品名称",prop:"work_name",type:"url",id:"work_id",url:"/workManager/workInfo/workInfoDetial?id="},
				{lable:"注册时间",prop:"register_time"},
				{lable:"收益发放时间",prop:"issue_reward_time"},
				{lable:"收益金额",prop:"reward_value",type:"price"},
			],
			action:{
				is_hidden:true,
				morebtns:{
					page:"holdAlltab"
				}
			}
		},
		// 用户信息表 table
    item0Label:{
			bts:[
				{prop:'open_id',lable:'用户ID'},
				{prop:'avatar',lable:'用户头像',type:'img'},
				{prop:'username',lable:'用户昵称'},
				{prop:'mobile',lable:'手机号码'},
				{prop:'video_collection',lable:'视频流收藏数'},
				{prop:'create_at',lable:'注册时间'}
			],
			action:{
				is_hidden:true,
				morebtns:{
					page:"labels"
				}
			}
		},
	}
}

export default screenData
